import onelps from '../../api';
import { INPUT_MINIMUM_LENGTH } from './common';
import { isQueryParamEqualTo, getQueryParam } from '../url';

export const resetPassword = async function(locale, token, newPassword, dispatchFn) {
	try {
		const payload = { token: token, password: newPassword };
		const result = await onelps.actions.resetPassword(payload, locale);

		return result;
	}
	catch(e) {
		dispatchFn({ type: 'SHOW_SERVER_ERROR' });
	}
};

export const isPasswordResetErrorResponse = (response) => response.errors;

export const isLongEnough = (password) => password.length >= INPUT_MINIMUM_LENGTH;
export const areEqual = (pass1, pass2) => pass1 === pass2;

export const isResetPwLink = () => isQueryParamEqualTo('account_recovery', 'true');
export const getEmailFromUrl = () => getQueryParam('email');
